import type { ProcessedProvider } from "../helpers";
import type { AvailableProvider } from "../components/DealerInfo/components/OnlinePaymentsConfig/types";

export function convertProcessedToAvailable(
  providers: ProcessedProvider[],
): AvailableProvider[] {
  return providers.map((provider) => {
    let parsedSchema: AvailableProvider["schema"];
    if (provider.schema) {
      try {
        parsedSchema =
          typeof provider.schema === "string"
            ? JSON.parse(provider.schema)
            : provider.schema;
      } catch {
        parsedSchema = undefined;
      }
    }

    const typeFromSchema = parsedSchema?.examples?.[0]?.type || "";
    const credentialsType =
      parsedSchema?.properties?.credentials?.properties?.type?.const || "";

    return {
      id: provider.id,
      name: provider.name,
      code: provider.code,
      type: typeFromSchema,
      priority: 1,
      methods: ["Credit"],
      credentials: {
        type: credentialsType,
      },
      schema: parsedSchema,
    };
  });
}
